import menuOrder from '@utils/menuOrder';
import { components } from '@pages/names';

export default (state = '', action = {}) => {
  if (!action.meta || !action.meta.location) {
    return state;
  }

  const type = action.type;
  const prevType = action.meta.location.prev.type;

  if (type === prevType) {
    return state;
  }

  let nextIdx = menuOrder.indexOf(components[type]);
  let prevIdx = menuOrder.indexOf(components[prevType]);

  if (nextIdx === -1 || prevIdx === -1) return '';
  return nextIdx < prevIdx ? 'back' : 'next';
};
